import React from 'react';
import { WidgetNotAvailable } from 'widgets/WidgetNotAvailable/WidgetNotAvailable';

export function WidgetNotAvailableInEnvironment() {
    return (
        <WidgetNotAvailable
            className="widget-not-available-in-environment"
            title={'This widget is not currently enabled'}
        />
    );
}
